import React from 'react';
import Image from "gatsby-plugin-sanity-image";

import classnames from "classnames";

import QuoteIcon from "../icons/Quote"

import "./CustomerQuote.scss";

const CustomerQuote = props => {
  const {children, author, hideThumbnail, className} = props;

  return (
    <blockquote className={classnames("CustomerQuote", className)}>
      <QuoteIcon />
      <p className="CustomerQuoteText">{children}</p>
      <footer className="CustomerQuoteFooter">
        <div className="CustomerQuoteAuthorInfos">
          {author?.name && <span className="CustomerQuoteAuthor">{author.name}</span>}
          {author?.jobtitle && <span className="CustomerQuoteJobTitle">{author.jobtitle}{author.company?.name && `, ${author.company.name}`}</span>}
        </div>
        {(!hideThumbnail && author?.image) && <Image
          {...author.image}
          width={88}
          className="CustomerQuoteImage"
          alt={author.name || ""}
        />}
      </footer>
    </blockquote>
  );
}

export default CustomerQuote;
